export default {
  setMigrationDialogHeader: 'Ustaw początek migracji',
  setMessage: 'Status migracji {count} {type} zostanie zresetowany, a wszystkie {type} zostaną ponownie zmigrowane od {date}.',
  setMigrationDialogErrorPast: 'Data musi być w przeszłości',
};
